/// <reference path="../../../../node_modules/monaco-editor/monaco.d.ts" />
import { Component, OnInit } from "@angular/core";
import { BaseComponent } from "../../shared/base.component";
import { ApiService } from "src/app/services";
import { LoadingScreenService } from "src/app/shared/loading-screen.service";
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute, Router } from "@angular/router";
import { ModalService } from "src/app/shared/modal.service";
import { ColDef, GridApi, GridOptions , GridReadyEvent } from "ag-grid-community";
import { PlanFile } from "src/app/generated-models/PlanFile";
import { extendDefaultOptions } from "src/app/utility/gridHelper";
import { PreprocessDateTime } from "src/app/utility/view-field-mapping";
import { PlanEditorModalOptions, PlanJsonSchema } from "./modals/plan-editor-modal/plan-editor-modal.component";
import { NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { PlanFileTypeEnum } from "src/app/shared/enums/plan-enums";
import { ActionCellComponent, ActionCellComponentParams } from "src/app/shared/grid/action-cell.component";

@Component({
  standalone: false,
  templateUrl: "./plan-history.component.html",
  styleUrls: ["../../styles.scss", "./plan.scss"],
})
export class PlanHistoryComponent extends BaseComponent implements OnInit {
  editorModal: NgbModalRef;
  serviceTreeId: string;
  planName: string;
  version: number;
  allPlanFiles: PlanFile[] = [];
  rowSourceData: PlanFile[] = [];
  gridOptions: GridOptions;
  gridApi: GridApi;
  initPageSize: number = 15;
  rowMergedData: PlanFile[] = [];
  gridOptionsMerged: GridOptions;
  gridApiMerged: GridApi;
  message: string;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private apiService: ApiService,
    protected modalService: ModalService,
    private loadingService: LoadingScreenService,
    private notificationService: ToastrService
  ) {
    super();
  }

  async ngOnInit() {
    this.serviceTreeId = this.route.snapshot.params["serviceTreeId"];
    this.planName = this.route.snapshot.params["name"];
    this.version = this.route.snapshot.params["version"];

    const planFilesColumnDefinition: ColDef[] = [
      {
        headerName: "Action",
        sortable: false,
        suppressMenu: true,
        cellRenderer: ActionCellComponent,
        cellRendererParams: {
          text: "View",
          actionFunc: this.viewPlanFile.bind(this),
        } as ActionCellComponentParams<PlanFile>,
      },
      {
        headerName: "Name",
        field: "FileName",
      },
      {
        headerName: "Last Modified",
        field: "LastModified",
        cellRenderer: (params) => PreprocessDateTime(params.value),
      },
    ];

    const planFilesMergedColumnDefinition: ColDef[] = [
      {
        headerName: "Action",
        sortable: false,
        suppressMenu: true,
        cellRenderer: ActionCellComponent,
        cellRendererParams: {
          text: "View",
          actionFunc: this.viewPlanFile.bind(this),
        } as ActionCellComponentParams<PlanFile>,
      },
      {
        headerName: "Name",
        field: "FileName",
      },
      {
        headerName: "Last Modified",
        field: "LastModified",
        cellRenderer: (params) => PreprocessDateTime(params.value),
      },
      {
        headerName: "File Type",
        field: "PlanFileType",
      },
    ];

    this.gridOptions = extendDefaultOptions({
      columnDefs: planFilesColumnDefinition,
      enableRangeSelection: false,
      rowSelection: "single",
      animateRows: true,
      sideBar: null,
    });

    this.gridOptionsMerged = extendDefaultOptions({
      onGridReady: (params: GridReadyEvent) => { this.gridApiMerged = params.api; },
      columnDefs: planFilesMergedColumnDefinition,
      enableRangeSelection: false,
      rowSelection: "single",
      animateRows: true,
      sideBar: null,
    });

    this.getPlanFiles();
  }

  onGridReady(params: GridReadyEvent): void {
    this.gridApi = params.api;
  }

  getPlanFiles(): void {
    this.loadingService.setLoading(true);

    this.apiService.getPlanFiles(this.serviceTreeId, this.planName, this.version).subscribe(
      (response) => {
        const original: PlanFile[] = [];
        const generated: PlanFile[] = [];
        response.forEach((plan) => {
          if (plan.FileName === "default.json") {
            original.push(plan);
            generated.push(plan);
          } else if (plan.FileName.includes("override")) {
            original.push(plan);
          } else {
            if (plan.PlanFileType === PlanFileTypeEnum.Generated) {
              generated.push(plan);
            } else {
              original.push(plan);
              generated.push(plan);
            }
          }
        });
        this.rowSourceData = original;
        this.rowMergedData = generated;
        this.allPlanFiles = response;
        this.loadingService.setLoading(false);
        setTimeout(() => {
          this.gridApi.autoSizeAllColumns();
          this.gridApiMerged.autoSizeAllColumns();
        }, 100);
      },
      (e: unknown) => {
        this.rowSourceData = [];
        this.rowMergedData = [];
        this.allPlanFiles = [];
        this.loadingService.setLoading(false);
        this.notificationService.error(e as string);
      }
    );
  }

  async viewPlanFile(planFile: PlanFile) {
    await this.showPlanEditorDialog(planFile);
  }

  async showPlanEditorDialog(planFile: PlanFile) {
    const options: PlanEditorModalOptions = {
      model: planFile,
      isReadonly: true,
      save: null,
      schema: null,
      serviceTreeId: this.serviceTreeId,
      planName: this.planName,
    };
    this.editorModal = await this.modalService.planEditorModal(options);
  }
}
